import React, { useState } from 'react';
import Header from "../../headerone/Main";
import Breadcrumb from "../../Breadcrumb/Main";
import { Col, Row } from "react-bootstrap";
import LeftEvents from "./LeftEvents";
import styles from "react-responsive-carousel/lib/styles/carousel.min.css";
import { Carousel } from "react-responsive-carousel";
import { Link } from "react-router-dom";

export default function TechnicalTalks() {


    const Data = [
        {
            venue: 'IIT Tirupati',
            title: "Application of Number Theory to Create a Secret Code",
            description: 'Talk on "Application of Number Theory to Create a Secret Code" by Dr. Mangala Narlikar, University of Pune.',
            img: [

                'https://files.iittp.ac.in/images/demo/iit/Events/2019/Mangala/1.jpg',
                'https://files.iittp.ac.in/images/demo/iit/Events/2019/Mangala/2.jpg',
                'https://files.iittp.ac.in/images/demo/iit/Events/2019/Mangala/3.jpg'
            ],
            dt: '29',
            my: 'Mar',
            category: '2019'
        },
        {
            venue: 'IIT Tirupati',
            title: "Faith, Identity and Reason",
            description: 'Talk on "Faith, Identity and Reason" by Prof. Sonia Sikka, University of Ottawa.',
            img: [
                'https://files.iittp.ac.in/images/demo/iit/Events/2019/philosophyday/2.jpg',
                'https://files.iittp.ac.in/images/demo/iit/Events/2019/philosophyday/4.jpg',
                'https://files.iittp.ac.in/images/demo/iit/Events/2019/philosophyday/5.jpg',
                'https://files.iittp.ac.in/images/demo/iit/Events/2019/philosophyday/6.jpg',
                'https://files.iittp.ac.in/images/demo/iit/Events/2019/philosophyday/7.jpg',
                'https://files.iittp.ac.in/images/demo/iit/Events/2019/philosophyday/8.jpg'
            ],
            dt: '28',
            my: 'Jan',
            category: '2019'
        },
        {
            venue: 'IIT Tirupati',
            title: "The Many Faces of Cryptography",
            description: 'Talk on "The Many Faces of Cryptography" by Dr. Nishanth Chandran, Microsoft Research.',
            img: [
                'https://files.iittp.ac.in/images/demo/iit/Events/2018/IndustryLecture4/L4.jpg'
            ],
            dt: '12',
            my: 'Oct',
            category: '2018'
        },
        {
            venue: 'IIT Tirupati',
            description: 'Talk on "Cyber Security - Overview, Incidents Services, Risks in Evolving Technologies & Trends" by Sachidananda S Javli, Director – Cyber Security, PwC India.',
            title: 'Cyber Security - Overview, Incidents Services, Risks in Evolving Technologies & Trends',
            img: [
                'https://files.iittp.ac.in/images/demo/iit/Events/2018/IndustryLecture3/L3.jpg'
            ],
            dt: '05',
            my: 'Oct',
            category: '2018'
        },
        {
            venue: 'IIT Tirupati',
            description: 'Talk on "Social Media Analytics" by Dr. Ponnurangam Kumaraguru, Associate Professor, IIIT-Delhi.',
            title: 'Social Media Analytics',
            img: [
                'https://files.iittp.ac.in/images/demo/iit/Events/2018/IndustryLecture2/lecture2.jpg'
            ],
            dt: '26',
            my: 'Sep',
            category: '2018'
        },
        {
            venue: 'IIT Tirupati',
            description: 'Talk on "Cloud Computing and DevOps" by Jitendra Thethi, AVP of Technology, Innovation at Aricent.',
            title: 'Cloud Computing and DevOps',
            img: [
                'https://files.iittp.ac.in/images/demo/iit/Events/2018/IndustryLecture1/lecture1.jpg'
            ],
            dt: '19',
            my: 'Sep',
            category: '2018'
        },
        {
            venue: 'IIT Tirupati',
            description: 'Dr. Reddy’s Foundation for Health Education (DRFHE) - Health Awareness session on "Hypertension" by Dr. P. Vasudev Shetty, MD DM Cardio from DVR & SK Super Speciality Hospital.',
            title: 'Hypertension',
            img: [
                'https://files.iittp.ac.in/images/demo/iit/Events/2018/HealthAwareness/1.jpg',
                'https://files.iittp.ac.in/images/demo/iit/Events/2018/HealthAwareness/2.jpg',
                'https://files.iittp.ac.in/images/demo/iit/Events/2018/HealthAwareness/3.jpg',
                'https://files.iittp.ac.in/images/demo/iit/Events/2018/HealthAwareness/4.jpg'
            ],
            dt: '28',
            my: 'Aug',
            category: '2018'
        },
        {
            venue: 'IIT Tirupati',
            description: 'Colloquium Talk on Digital India Awareness Program by S.Sankar Raj - Prompt Infotechs resource person ',
            title: 'Digital India Awareness',
            img: [
                'https://files.iittp.ac.in/images/demo/iit/Events/Digitalindia/1.jpg',
                'https://files.iittp.ac.in/images/demo/iit/Events/Digitalindia/2.jpg',
                'https://files.iittp.ac.in/images/demo/iit/Events/Digitalindia/3.jpg',
            ],
            dt: '28',
            my: 'Aug',
            category: '2017'
        },

        {
            venue: 'IIT Tirupati',
            description: 'Colloquium Talk on Drone Based Experimental Investigation of Flow around Multi-MW Wind Farms in Flat and Complex Terrains by Dr. Balaji Subramanian from University of California Santa Barbara (UCSB) ',
            title: 'Drone Based Experimental',
            img: [
                'https://files.iittp.ac.in/images/demo/iit/Events/Balajisub/1.jpg',
                'https://files.iittp.ac.in/images/demo/iit/Events/Balajisub/2.jpg'

            ],
            dt: '28',
            my: 'Aug',
            category: '2017'
        },

        {
            venue: "IIT Tirupati",
            description: "Special Lecture by Interns of XLr8 Tirupati",
            title: "Interns of XLr8",
            img: [
                "https://files.iittp.ac.in/images/demo/iit/Events/XLR82017/1.jpg",
                "https://files.iittp.ac.in/images/demo/iit/Events/XLR82017/2.jpg",
                "https://files.iittp.ac.in/images/demo/iit/Events/XLR82017/3.jpg",
                "https://files.iittp.ac.in/images/demo/iit/Events/XLR82017/4.jpg"
            ],
            dt: "09",
            my: "Aug",
            category: "2017"
        },

        {
            venue: "IIT Tirupati",
            description: "Lecture on MANAGEMENT ETHOS – ANCIENT INDIAN KNOWLEDGE PERSPECTIVE by Prof. Rani Sadasiva Murty - Coordinator, Rashtriya Sanskrit Vidyapeetha",
            title: "MANAGEMENT ETHOS – ANCIENT INDIAN KNOWLEDGE PERSPECTIVE",
            img: [
                "https://files.iittp.ac.in/images/demo/iit/Events/SadaSivaMurthy/2.jpg",
                "https://files.iittp.ac.in/images/demo/iit/Events/SadaSivaMurthy/3.jpg"
            ],
            dt: "09",
            my: "Aug",
            category: "2017"
        },

        {
            venue: "IIT Tirupati",
            description: "Colloquium Talk on NUMERICAL SIMULATIONS IN ENGINEERING: THE THIRD SCIENTIFIC METHODOLOGY by Prof. J.N. Reddy - Regents Professor of Mechanical Engineering, Texas A&M University",
            title: "NUMERICAL SIMULATIONS IN ENGINEERING",
            img: [
                "https://files.iittp.ac.in/images/demo/iit/Events/JNReddy/1.jpg",
                "https://files.iittp.ac.in/images/demo/iit/Events/JNReddy/2.jpg"
            ],
            dt: "08",
            my: "Aug",
            category: "2017"
        },

        {
            venue: "IIT Tirupati",
            description: "Faculty - In House Symposium",
            title: "In House Symposium",
            img: [
                "https://files.iittp.ac.in/images/demo/iit/Events/FIHS/1.jpg",
                "https://files.iittp.ac.in/images/demo/iit/Events/FIHS/2.jpg",
                "https://files.iittp.ac.in/images/demo/iit/Events/FIHS/3.jpg",
                "https://files.iittp.ac.in/images/demo/iit/Events/FIHS/4.jpg",
                "https://files.iittp.ac.in/images/demo/iit/Events/FIHS/5.jpg",
                "https://files.iittp.ac.in/images/demo/iit/Events/FIHS/6.jpg",
                "https://files.iittp.ac.in/images/demo/iit/Events/FIHS/7.jpg",
                "https://files.iittp.ac.in/images/demo/iit/Events/FIHS/8.jpg",
                "https://files.iittp.ac.in/images/demo/iit/Events/FIHS/9.jpg",
                "https://files.iittp.ac.in/images/demo/iit/Events/FIHS/10.jpg",
                "https://files.iittp.ac.in/images/demo/iit/Events/FIHS/11.jpg",
                "https://files.iittp.ac.in/images/demo/iit/Events/FIHS/13.jpg"
            ],
            dt: "02",
            my: "May",
            category: "2017"
        },

        {
            venue: "IIT Tirupati",
            description: "11th In-House Symposium in Atomic and Molecular Physics.",
            title: "Atomic and Molecular Physics",
            img: [],
            dt: "09",
            my: "March",
            category: "2017"
        },
        {
            venue: "IIT Tirupati",
            description: "Colloquium talk, “The Physics of Atoms: where we are, and where we are going”, by Prof. S. T. Manson, Department of Physics and Astronomy, Georgia State University, Atlanta, USA.",
            title: "The Physics of Atoms",
            img: [],
            dt: "08",
            my: "March",
            category: "2017"
        },

        {
            venue: "IIT Tirupati",
            description: "Colloquium talk on “Liquid Sprays: Application and diagnostics with focus on automotive fuel injection” by Dr. Madhan Mohan Avulapati, Department of Mechanical Engineering, IIT Tirupati.",
            title: "Liquid Sprays",
            img: [],
            dt: "01",
            my: "March",
            category: "2017"
        },

        {
            venue: "IIT Tirupati",
            description: "Colloquium talk, “An overview of the Remarkable Lambert W function”, by Prof. S. R. Valluri, Department of Physics and Astronomy, University of Western Ontario, London, Canada.",
            title: "An overview of the Remarkable Lambert W function",
            img: [],
            dt: "01",
            my: "March",
            category: "2017"
        },

        {
            venue: "IIT Tirupati",
            description: "Special interactive talk by Mr. Glenn Robinson, the managing director of XLr8 Andhra Pradesh.",
            title: "interactive talk",
            img: [
                "https://files.iittp.ac.in/images/demo/iit/Events/TechEvents/XLR/1.jpg",
                "https://files.iittp.ac.in/images/demo/iit/Events/TechEvents/XLR/2.jpg"
            ],
            dt: "22",
            my: "Feb",
            category: "2017"
        },
        {
            venue: "IIT Tirupati",
            description: "Colloquium talk on “Metal halide perovskites: a new family of semiconductors for photovoltaics” by Dr. N Ravi Chandra Raju, University of Queensland, Australia.",
            title: "Metal halide perovskites",
            img: [],
            dt: "15",
            my: "Feb",
            category: "2017"
        },
        {
            venue: "IIT Tirupati",
            description: "Colloquium talk on “Understanding Fen Hydrology – a Data-intensive Groundwater Modeling Approach” by Dr. Prasanna V Sampath, Department of Chemical Engineering, IIT Tirupati.",
            title: "Understanding Fen Hydrolog",
            img: [],
            dt: "01",
            my: "Feb",
            category: "2017"
        },
        {
            venue: "IIT Tirupati",
            description: "Colloquium talk on “New Paradigms in Engineering Education” by Prof. Sadanand Gokhale, Director, LNM Institute of Information Technology, Jaipur.",
            title: "New Paradigms in Engineering Education",
            img: [],
            dt: "23",
            my: "January",
            category: "2017"
        },
        {
            venue: "IIT Tirupati",
            description: "Colloquium talk on “Glimpses on Fourier Series” by Prof. V. Raghavendra, Department of Mathematics, IIT Tirupati.",
            title: "Glimpses on Fourier Series",
            img: [],
            dt: "18",
            my: "January",
            category: "2017"
        },
        {
            venue: "IIT Tirupati",
            description: "Colloquium talk on “Electrospinning” by Prof. T S Natarajan, Department of Physics, IIT Tirupati.",
            title: "Electrospinning",
            img: [],
            dt: "11",
            my: "January",
            category: "2017"
        },
        {
            venue: "IIT Tirupati",
            description: "Colloquium talk on “Recent trends in Telecom: How to Connect the unconnected” by Dr. Lakshmi.",
            title: "Recent trends in Telecom",
            img: [],
            dt: "4",
            my: "January",
            category: "2017"
        },
        {
            venue: "IIT Tirupati",
            description: "Colloquium talk on “Cryptography and it Applications in Information and Cyber Security” by Dr. Vishal Sgaraswat.",
            title: "Cryptography and it Applications in Information and Cyber Security",
            img: [],
            dt: "4",
            my: "January",
            category: "2017"
        },


        {
            venue: "IIT Tirupati",
            description: "Special Lecture on Manufacturing for Human Wellness and a Wearable Revolution by Prof. Satish T.S",
            title: "Human Wellness and a Wearable Revolution",
            img: [
                "https://files.iittp.ac.in/images/demo/iit/Events/TechEvents/Satish/1.JPG",
                "https://files.iittp.ac.in/images/demo/iit/Events/TechEvents/Satish/2.JPG",
                "https://files.iittp.ac.in/images/demo/iit/Events/TechEvents/Satish/3.JPG",
                "https://files.iittp.ac.in/images/demo/iit/Events/TechEvents/Satish/4.JPG",
                "https://files.iittp.ac.in/images/demo/iit/Events/TechEvents/Satish/5.JPG",
                "https://files.iittp.ac.in/images/demo/iit/Events/TechEvents/Satish/6.JPG"
            ],
            dt: "10",
            my: "August",
            category: "2016"
        },
        {
            venue: "IIT Tirupati",
            description: "A special lecture titled ‘Technology Careers in a Hyperconnected World’ by Mr. K. Ananth Krishnan, Chief Technology Officer, Tata Consultancy Services (TCS)",
            title: "Technology Careers in a Hyperconnected World",
            img: [
                "https://files.iittp.ac.in/images/demo/iit/Events/TechEvents/TCS/1.JPG",
                "https://files.iittp.ac.in/images/demo/iit/Events/TechEvents/TCS/2.JPG",
                "https://files.iittp.ac.in/images/demo/iit/Events/TechEvents/TCS/3.JPG",
                "https://files.iittp.ac.in/images/demo/iit/Events/TechEvents/TCS/4.JPG"
            ],
            dt: "31",
            my: "March",
            category: "2016"
        },
        {
            venue: "IIT Tirupati",
            description: "Science Day lecture titled ‘Ripples in Space Time: A New Window to the Universe’ by Prof. L. Sriramkumar, IIT Madras",
            title: "Ripples in Space Time",
            img: [],
            dt: "1",
            my: "March",
            category: "2016"
        },
        {
            venue: "IIT Tirupati",
            description: "A special talk titled ‘Resolving Atom in Our Backyards: Indigenous Technology in a Globalized World’ by Prof. Deshdeep Sahdev, Quazar Technologies, and former Professor, IIT Kanpur",
            title: "Resolving Atom in Our Backyards",
            img: [],
            dt: "19",
            my: "February",
            category: "2016"
        },
        {
            venue: "IIT Tirupati",
            description: "A speech on career development by Prof. Ravikumar Bhaskaran, formerly Dean Continuing Education and Principal QIP Coordinator, IIT Kharagpur",
            title: "career development",
            img: [],
            dt: "10",
            my: "February",
            category: "2016"
        },
        {
            venue: "IIT Tirupati",
            description: "A PAN IIT alumni meeting was held in the IIT Tirupati campus. The meeting was jointly organised by Prof. Satyanarayana, Professor-in-Charge, IIT Tirupati and Prof. Nagarajan, Dean, Alumni Affairs, IIT Madras.",
            title: "A PAN IIT alumni meeting",
            img: [
                "https://files.iittp.ac.in/images/demo/iit/Events/TechEvents/PANIIT/1.JPG",
                "https://files.iittp.ac.in/images/demo/iit/Events/TechEvents/PANIIT/2.JPG",
                "https://files.iittp.ac.in/images/demo/iit/Events/TechEvents/PANIIT/3.JPG",
                "https://files.iittp.ac.in/images/demo/iit/Events/TechEvents/PANIIT/4.JPG"
            ],
            dt: "6",
            my: "February",
            category: "2016"
        },


        {
            venue: "IIT Tirupati",
            description: "A speech on innovation by Dr. Mahesh Panchagnula, Professor of Applied Mechanics, IIT Madras",
            title: "speech on innovation",
            img: [],
            dt: "19",
            my: "Sep",
            category: "2015"
        },
        
        {
            venue: "IIT Tirupati",
            description: "A motivational speech by Dr. L.S. Ganesh, Professor of Management Studies, IIT Madras",
            title: "A motivational speech",
            img: [],
            dt: "27",
            my: "August",
            category: "2015"
        }

];



    const [activeButton, setActiveButton] = useState("View All");
    const [current, setcurrent] = useState(Data);

    const Filter = (category) => {
        setActiveButton(category);
        const arr = [];
        if (category === "View All") {
            setcurrent(Data);
        } else {
            Data.map((item) => {
                if (item.category === category) {
                    arr.push(item);
                }
            });
            setcurrent(arr);
        }
    };

    function chunkArray(array, chunkSize) {
        const chunkedArray = [];
        for (let i = 0; i < array.length; i += chunkSize) {
            chunkedArray.push(array.slice(i, i + chunkSize));
        }
        return chunkedArray;
    }

    const [expandedDescriptions, setExpandedDescriptions] = useState({});

    // Function to toggle the description expansion
    const toggleDescriptionExpansion = (index) => {
        setExpandedDescriptions({
            ...expandedDescriptions, [index]: !expandedDescriptions[index],
        });
    };

    return (<div className="technical-talks">
        <Header />
        <Breadcrumb subtitle={"Technical Talks"} title={"Home"} />

        <section className="project-detail">
            <div className="container">
                <div className="section-title center-align mb-50 wow fadeInDown animated"
                    data-animation="fadeInDown" data-delay=".4s">
                    <h5><i className="fal fa-calendar" /> Events</h5>
                    <h2>Technical Talks</h2>
                </div>
                <Row>
                    <Col md={4} className="c-left">
                        <LeftEvents activeIndex={2} />
                    </Col>

                    <Col md={8} className="c-left">
                        <div className="row align-items-end">
                            <div className="col-lg-12">
                                <div className="my-masonry text-center mb-50 wow fadeInRight animated"
                                    data-animation="fadeInRight" data-delay=".4s">
                                    <div className="button-group filter-button-group ">
                                        <button className={`${activeButton === "View All" ? "active" : ""}`}
                                            data-filter="*" onClick={() => Filter("View All")}> View All
                                        </button>
                                        <button className={`${activeButton === "2019" ? "active" : ""}`}
                                            data-filter=".2019" onClick={() => Filter("2019")}>2019
                                        </button>
                                        <button className={`${activeButton === "2018" ? "active" : ""}`}
                                            data-filter=".2018" onClick={() => Filter("2018")}>2018
                                        </button>
                                        <button className={`${activeButton === "2017" ? "active" : ""}`}
                                            data-filter=".2017" onClick={() => Filter("2017")}>2017
                                        </button>
                                        <button className={`${activeButton === "2016" ? "active" : ""}`}
                                            data-filter=".2016" onClick={() => Filter("2016")}>2016
                                        </button>
                                        <button className={`${activeButton === "2015" ? "active" : ""}`}
                                            data-filter=".2015" onClick={() => Filter("2015")}>2015
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                        {chunkArray(current, 2).map((row, rowIndex) => (<Row key={rowIndex}>
                            {row.map((event, index) => (
                                <Col key={index} lg={6} md={6} sm={12} className="wow fadeInUp animated"
                                    data-animation="fadeInUp" data-delay=".4s">
                                    <div className="event-item mb-30 hover-zoomin">
                                        <div className="thumb">
                                            <Carousel showArrows={true} showThumbs={false} dynamicHeight={false}
                                                selectedItem={0}>
                                                {event.img.map((image, imgIndex) => (<div key={imgIndex}>
                                                    <img src={image} alt={`event-img-${imgIndex}`} />
                                                </div>))}
                                            </Carousel>
                                        </div>
                                        <div className="event-content">
                                            <div className="date">
                                                <strong>{event.dt}</strong> {event.my}
                                            </div>
                                            <h3 style={{ minHeight: "87px" }}>
                                                <Link to={event.link}> {event.title}</Link>
                                            </h3>
                                            <p>
                                                {expandedDescriptions[index] ? event.description : event.description.split(' ').slice(0, 20).join(' ')}
                                                {event.description.split(' ').length > 20 && (
                                                    <span className="read-more">
                                                        <button style={{
                                                            textDecoration: "underline",
                                                            color: "#007bff",
                                                            cursor: 'pointer',
                                                            padding: '0',
                                                            border: 'none',
                                                            background: 'none'
                                                        }}
                                                            onClick={() => toggleDescriptionExpansion(index)}>
                                                            {expandedDescriptions[index] ? " Show Less" : "...Show More"}
                                                        </button>
                                                    </span>)}
                                            </p>
                                            <div className="time">
                                                {event.duration} <i className="fal fa-long-arrow-right" />{" "}
                                                <strong>{event.venue}</strong>
                                            </div>
                                        </div>
                                    </div>
                                </Col>))}
                        </Row>))}
                    </Col>
                </Row>
            </div>
        </section>
    </div>);
}
